import React from "react";
import MyHealthComponent from "./MyHealthComponent";
import { useMeasureUnits } from "@aetonix/hooks";

export default function Weight(props) {
	var model = props.model;
	var weight = model.weight;

	var steps = weight.cumulative;
	var reverse_steps = weight.reverse; // needed for chart
	var readFromDevice = props.readFromDevice;

	var today = null;
	var section = model.page;

	const { weightUnits } = useMeasureUnits();
	var textformat = "{" + weightUnits + "}";

	// Sets up the format to the 'today' button
	if (steps.length) {
		var graphdata = adjust_time(reverse_steps, null, weightUnits).slice(-10); // for chart
		today = steps[0].history[weightUnits];
	}

	return (
		<MyHealthComponent model={model} section={section} textformat={textformat} latestReading={today}
			reverseEntries={graphdata} activeModel={weight} units={weightUnits} xaxis={"x"} yaxis={"y"}
			readFromDevice={readFromDevice} />
	);
}

function adjust_time(data, forBoxGraphic, weightUnits) {
	var adjusted = data.map(function (item) {
		var time = time_label(item.updated_at, false);
		var value = (typeof item.history[weightUnits] === "string")
			? parseFloat(item.history[weightUnits])
			: item.history[weightUnits];
		return {
			x: time,
			y: value
		};
	});
	return adjusted;
}

function time_label(data, forBoxGraphic) {
	var parsed = time_parse(data, forBoxGraphic);

	return (parsed.month + "-" + parsed.day + "  " + parsed.time);
}

function time_parse(data, forBoxGraphic) {
	var date = new Date(data);
	var month = date.getMonth() + 1;
	var day = date.getDate();
	day = two_digit(day);
	month = two_digit(month);
	var hours = two_digit(date.getHours());
	var minutes = two_digit(date.getMinutes());
	var seconds = forBoxGraphic ? "" : ":" + two_digit(date.getSeconds());
	var time = hours + ":" + minutes + seconds;

	return {
		month: month,
		day: day,
		time: time
	};
}

function two_digit(data) {
	var item = (data < 10)
		? "0" + data
		: data;
	return item;
}
